import { z } from 'zod';

const AGENT_AFFECTED_REF_KINDS = [
  'doc',
  'block',
  'canvas_element',
  'workflow',
  'node',
] as const;

export const AgentAffectedRefSchema = z.object({
  kind: z.enum(AGENT_AFFECTED_REF_KINDS),
  workspaceId: z.string(),
  docId: z.string().optional(),
  blockId: z.string().optional(),
  elementId: z.string().optional(),
  workflowId: z.string().optional(),
  nodeId: z.string().optional(),
});

export type AgentAffectedRef = z.infer<typeof AgentAffectedRefSchema>;
